import { Loading } from "./Loading/Loading";
import React, { Suspense } from "react";

function SuspenseWrapper({ children }: { children?: React.ReactNode }) {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
}

export default SuspenseWrapper;
